import FingerprintJS from '@fingerprintjs/fingerprintjs';

let fpPromise = null;

function getFingerprint() {
  if (!fpPromise) {
    fpPromise = FingerprintJS.load();
  }
  return fpPromise;
}

export async function getDeviceFingerprint() {
  try {
    const fp = await getFingerprint();
    const result = await fp.get();
    
    // Collect extra device info for admin display
    const screen = `${window.screen.width}x${window.screen.height}`;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const language = navigator.language || navigator.userLanguage || 'unknown';
    const platform = navigator.platform || 'unknown';
    const cores = navigator.hardwareConcurrency || 0;
    const touchSupport = navigator.maxTouchPoints > 0;
    
    return {
      visitor_id: result.visitorId,
      confidence: Math.round((result.confidence?.score || 0) * 100),
      screen_resolution: screen,
      timezone,
      language,
      platform,
      cpu_cores: cores,
      is_mobile: touchSupport && /Mobile|Android|iPhone/i.test(navigator.userAgent),
    };
  } catch (err) {
    console.warn('Fingerprint collection failed:', err);
    return null;
  }
}
